import React from 'react';
import NumberFormat from 'react-number-format';
import { v4 as uuidv4 } from 'uuid';

const customFormatComponent = props => {
  const { onChange, inputRef, ...rest } = props;

  return (
    <NumberFormat
      {...rest}
      id={uuidv4()}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      decimalScale={0}
    />
  );
};

export default customFormatComponent;



// WEBPACK FOOTER //
// ./src/sharedComponents/InputWithSlider/components/CustomNumberInput/CustomNumberInput.js